import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslocoService } from '@jsverse/transloco';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { ToastrService } from 'ngx-toastr';

import { AssignmentsService } from '../../../../../services/assignments.service';
import { AssignmentCancellationPostModel } from '../../../models/assignment-cancellation-post.model';

@Component({
    selector: 'app-assignment-cancel-modal',
    templateUrl: './assignment-cancel-modal.component.html',
    styleUrl: './assignment-cancel-modal.component.scss'
})
export class AssignmentCancelModalComponent implements OnInit {
    @Input() assignmentId!: number;
    @Output() onSuccess = new EventEmitter<boolean>();

    protected isError: boolean = false;
    protected errorMessage: string | null = null;;
    protected cancellationForm!: FormGroup;
    protected isLoading: boolean = false;
    protected isSubmitted: boolean = false;

    constructor(
        private formBuilder: FormBuilder,
        private bsModalRef: BsModalRef,
        private assignmentService: AssignmentsService,
        private toastrService: ToastrService,
        private translocoService: TranslocoService
    ) { }

    ngOnInit(): void {
        this.initForm();
    }

    private initForm(): void {
        this.cancellationForm = this.formBuilder.group({
            cancellationReason: ['', Validators.required],
            isCancellationConfirmed: [false, Validators.requiredTrue]
        })
    }

    protected cancelAssignment(): void {
        this.isSubmitted = true;
        this.cancellationForm.markAllAsTouched();
        if (!this.cancellationForm.valid) return;

        this.isLoading = true;

        const isCancellationConfirmed: boolean = this.cancellationForm.value.isCancellationConfirmed;
        if (!isCancellationConfirmed) return;

        const cancellationModel: AssignmentCancellationPostModel = {
            cancellationReason: this.cancellationForm.value.cancellationReason,
        };

        this.assignmentService.cancelAssignment(this.assignmentId, cancellationModel).subscribe({
            next: (response) => {
                if (response.isSuccess) {
                    this.toastrService.success(this.translocoService.translate('assignments.information.cancelSuccess'));
                    this.onSuccess.next(true);
                    this.bsModalRef.hide();
                    return;
                }

                this.isError = true;
                this.errorMessage = response.errorMessage;
                this.isLoading = false;
            },
            error: (err) => {
                this.isError = true;
                this.isLoading = false;
            }
        });
    }
}
